export const MAX_PRICE = 1000000;

export const CARD_TYPE = {
  1: {cardIcon: 'Visa', cardName: 'VISA'},
  2: {cardIcon: 'MasterCard', cardName: 'MASTER CARD'},
  3: {cardIcon: 'Amex', cardName: 'AMERICAN EXPRESS'},
  4: {cardIcon: 'Discover', cardName: 'DISCOVER'},
};

export const SELLER_METHODS_TYPES = {
  PAYPAL: 'paypal',
  BANK_ACCOUNT: 'ach',
};

export const PAYOUT_HISTORY_FILTER_PERIODS = {
  ALL: 'all',
  LAST_7: 'last7',
  LAST_30: 'last30',
  LAST_90: 'last90',
  THIS_YEAR: 'thisYear',
  PAST_YEAR: 'pastYear',
};

export const PUBLISH_METHOD = ['PUT', 'POST'];

export const SELLER_TYPE = {
  PRIVATE: 'private',
  BUSINESS: 'business',
};

export const FORM_SCHEMA = {
  FIRST_NAME: 'firstName',
  LAST_NAME: 'lastName',
  COUNTRY: 'countryCode',
};

export const POSITIONS = {
  TOP: 'top',
};
